import React from 'react'
import className from 'classnames/bind'

import style from './MyhousePhotoTooltip.module.scss'

import { IMAGE_ACCEPT_TYPE } from '@Root/contants/myhouseRegister'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  isShow: boolean
  setIsShow: (isShow: boolean) => void
  onTakePictureChange: any
}

const MyhousePhotoTooltip: React.FC<Props> = ({ isShow, setIsShow, onTakePictureChange }: Props) => {
  return (
    <div className={cx('article', isShow && 'is_show')}>
      <div className={cx('tooltip')}>
        <strong className={cx('title')}>촬영 전 주의사항</strong>
        <p className={cx('text')}>
          우리집 주소지를 제외한{' '}
          <em className={cx('emphasis')}>
            개인정보를
            <br /> 모두 마스킹 처리
          </em>
          한 뒤 촬영해 주세요!
        </p>
        <ul className={cx('list')}>
          <li className={cx('item')}>
            ・ 고객님을 포함한 개인의 이름,
            <br />
            전화번호, 이메일 주소
          </li>
          <li className={cx('item')}>・ 우편/택배물 발송자의 주소지</li>
          <li className={cx('item')}>・ 주문품목</li>
          <li className={cx('item')}>・ 개인의 계좌번호(관리비 고지서의 임시 계좌번호는 허용)</li>
          <li className={cx('item')}>・ 주민등록번호 뒤 7자리</li>
        </ul>
        <em className={cx('warning')}>
          불필요한 개인정보가 포함된 경우
          <br /> 검수가 반려됩니다.
        </em>
        <div className={cx('button_area')}>
          <button type="button" className={cx('button_cancel')} onClick={handleNclickMix(NCLICK.MY_HOUSE.AUTHENTICATION.ATTACH_CAUTION_POPUP.CLOSE, () => setIsShow(false))}>
            닫기
          </button>
          <span className={cx('button_photo')}>
            <input
              id="input_photo"
              type="file"
              accept={IMAGE_ACCEPT_TYPE}
              onChange={onTakePictureChange}
              onClick={handleNclickMix(NCLICK.MY_HOUSE.AUTHENTICATION.ATTACH_CAUTION_POPUP.START)}
              className="blind"
            />
            <label htmlFor="input_photo" className={cx('label')}>
              촬영 시작
            </label>
          </span>
        </div>
      </div>
    </div>
  )
}

export default MyhousePhotoTooltip
